import Controller from './calendar-day.controller';
import template from './calendar-day.html';
import './calendar-day.less';

const Component = {
    template,
    require: {
        calendar: '^crCalendar',
    },
    bindings: {
        schedule: '<',
    },
    controller: ['$interval', '$timeout', Controller],
};

export default Component;
